export const mockData = {
  sidebar: {
    bodycamFootage: [
      {
        id: 'bc-1',
        title: 'Traffic Stop – DUI Arrest, Highway 26',
        date: '2024-01-15',
      },
      {
        id: 'bc-2',
        title: 'Domestic Disturbance – 1245 Oak Street',
        date: '2024-01-14',
      },
      {
        id: 'bc-3',
        title: 'Stolen Vehicle Recovery – Mall Parking Lot',
        date: '2024-01-13',
      },
      {
        id: 'bc-4',
        title: 'Welfare Check – Elderly Resident Assist',
        date: '2024-01-12',
      },
    ],
    chatHistory: [
      {
        id: 'ch-1',
        title: 'Willow Street Burglary – Patrol Report Draft',
        date: '2024-01-15',
      },
      {
        id: 'ch-4',
        title: 'Crisis Response Guidance',
        date: '2024-01-14',
      },
      {
        id: 'ch-5',
        title: 'Community Engagement Planning',
        date: '2024-01-13',
      },
    ],
    fieldNotes: [
      {
        id: 'fn-1',
        title: 'Willow Street Burglary',
        date: '2024-01-15',
      },
      {
        id: 'fn-2',
        title: '1104 Main Street',
        date: '2024-01-15',
      },
      {
        id: 'fn-3',
        title: 'Suspicious Activity - 4th & Main',
        date: '2024-01-14',
      },
    ],
    fieldNotesFeed: [
      {
        id: 'feed-1',
        type: 'transcript',
        content:
          'Subject was wearing a red hoodie and dark jeans, heading north on foot.',
        timestamp: '14:22',
        incident: 'Willow Street Burglary',
      },
      {
        id: 'feed-2',
        type: 'transcript',
        content:
          'Partial plate, white cargo van — reads "L7K". Couldn\'t get the rest.',
        timestamp: '14:25',
        incident: '1104 Main Street',
      },
      {
        id: 'feed-typed-1',
        type: 'typed',
        content:
          'Homeowner reports a similar van seen in the neighborhood three days ago. No neighbor camera footage available yet.',
        timestamp: '14:28',
        incident: 'Willow Street Burglary',
      },
      {
        id: 'feed-3',
        type: 'transcript',
        content:
          'Witness heard a loud bang right before the alarm went off.',
        timestamp: '14:30',
        incident: 'Willow Street Burglary',
      },
      {
        id: 'feed-typed-2',
        type: 'typed',
        content:
          'Perimeter verified. Rear entry point secured with temporary board-up. Evidence team notified of possible tool marks on the frame.',
        timestamp: '14:32',
        incident: 'Willow Street Burglary',
      },
      {
        id: 'feed-4',
        type: 'transcript',
        content: 'Back door shows forced entry — looks like a pry bar.',
        timestamp: '14:35',
        incident: 'Willow Street Burglary',
      },
      {
        id: 'feed-typed-long',
        type: 'typed',
        content:
          'Searched the alleyway. Found discarded packaging for a high-end electronics item near the dumpster, matches description of goods taken from the master bedroom. Fresh tire tracks in the mud leading away from the scene toward the main road. Requesting traffic-cam review for the 14:00–15:00 window.',
        timestamp: '14:40',
        incident: 'Willow Street Burglary',
      },
      {
        id: 'feed-5',
        type: 'transcript',
        content:
          'On scene at 1104 Main. Large dog loose in the front yard, acting aggressive. Prior disturbance history at this address.',
        timestamp: '14:45',
        incident: '1104 Main Street',
      },
      {
        id: 'feed-6',
        type: 'typed',
        content:
          'Requested animal control. Occupant at 1104 Main refusing to come to the door.',
        timestamp: '14:50',
        incident: '1104 Main Street',
      },
      {
        id: 'feed-7',
        type: 'transcript',
        content:
          'Neighbor at 1106 Main says they heard shouting from the residence about ten minutes before I arrived.',
        timestamp: '14:55',
        incident: '1104 Main Street',
      },
      {
        id: 'feed-8',
        type: 'typed',
        content:
          'Animal control on scene. Canine secured. Moving to the front entrance for contact.',
        timestamp: '15:05',
        incident: '1104 Main Street',
      },
      {
        id: 'feed-9',
        type: 'transcript',
        content:
          'Subject is Marcus V., DOB 11/12/85. Highly agitated. No weapons visible within reach.',
        timestamp: '15:12',
        incident: '1104 Main Street',
      },
      {
        id: 'feed-10',
        type: 'typed',
        content:
          'Requested a secondary unit for scene safety. Disturbance appears to be a verbal dispute over property boundaries.',
        timestamp: '15:20',
        incident: '1104 Main Street',
      },
      {
        id: 'feed-11',
        type: 'transcript',
        content:
          'Canvassing for additional witnesses. Mrs. Gable at 125 Willow saw a white van parked near the hydrant around 21:15.',
        timestamp: '15:30',
      },
      {
        id: 'feed-12',
        type: 'typed',
        content:
          'Collected latent prints from the rear door handle. Evidence bag #4421-B. Transporting to lab for processing.',
        timestamp: '15:45',
      },
      {
        id: 'feed-13',
        type: 'transcript',
        content:
          'Homeowner says a jewelry box is missing from the master bedroom, estimated value $5,000. Nothing else high-value disturbed.',
        timestamp: '16:02',
      },
      {
        id: 'feed-14',
        type: 'typed',
        content:
          'Scene processed. Perimeter tape removed. Homeowner advised of the case number and insurance next steps.',
        timestamp: '16:15',
      },
      {
        id: 'feed-15',
        type: 'transcript',
        content:
          'Subject at 1104 Main has retreated inside and is refusing further contact. Requesting a supervisor for a possible barricade situation.',
        timestamp: '15:35',
        incident: '1104 Main Street',
      },
      {
        id: 'feed-16',
        type: 'typed',
        content:
          'Contacted secondary witness at 1102 Main. Shouting started around 14:40. Witness saw a male matching Marcus V. pacing the yard.',
        timestamp: '15:42',
        incident: '1104 Main Street',
      },
      {
        id: 'feed-17',
        type: 'transcript',
        content:
          'Requesting EMS. Marcus V. is complaining of chest pain through the closed door. Holding the perimeter until medical arrives.',
        timestamp: '15:50',
        incident: '1104 Main Street',
      },
      {
        id: 'feed-18',
        type: 'typed',
        content:
          'BOLO issued: white cargo van, partial plate L7K, last seen eastbound on Highway 26. Linked to the Willow Street Burglary investigation.',
        timestamp: '16:10',
        incident: 'Willow Street Burglary',
      },
    ],
    passOns: [
      {
        id: 'po-1',
        title: 'Shift Change: Perimeter Secure',
        date: '2024-01-15',
      },
      {
        id: 'po-2',
        title: 'BOLO: Blue Truck, Partial Plate 44X',
        date: '2024-01-15',
      },
      {
        id: 'po-3',
        title: 'Equipment Issue: Unit 402 Radio',
        date: '2024-01-14',
      },
    ],
    activeIncidents: [
      {
        id: 'incident-1',
        title: '1104 Main Street',
        date: '2024-01-15',
      },
      {
        id: 'incident-2',
        title: '2847 Oak Avenue',
        date: '2024-01-15',
      },
      {
        id: 'incident-3',
        title: '615 Elm Street',
        date: '2024-01-15',
      },
    ],
  },
  conversations: {
    'notification-alert': [
      {
        id: '1',
        content:
          "Dispatching to 1104 Main Street. Pre-arrival brief is ready: two prior disturbance calls here in the last 90 days and an active dangerous-dog flag from a 2023 animal-control report. Approach from the driver's side — the dog run is on the east fence line. Hotkey when you're set and I'll capture your notes hands-free.",
        role: 'assistant',
        timestamp: new Date(Date.now() - 120000),
      },
    ],
    'incident-1': [
      {
        id: '1',
        content:
          "Dispatching to 1104 Main Street. Here's your pre-arrival brief. History at this address: two disturbance calls in the last 90 days, both verbal with no arrests, and one dangerous-dog flag on file from a 2023 animal-control report. NCIC is clear on the registered occupant. If this turns into a custody decision, General Order 6.3 (Response to Persons in Crisis) and the parish dangerous-dog ordinance both apply — I'll surface the relevant sections on request. Approach from the driver's side; the dog run is on the east fence line. Hotkey when it's safe and I'll capture your notes hands-free.",
        role: 'assistant',
        timestamp: new Date(Date.now() - 180000),
      },
    ],
    'incident-2': [
      {
        id: '1',
        content:
          "Dispatching to 2847 Oak Avenue. Pre-arrival brief: one prior weapons call here in 2024 (no charges filed) and a mental-health flag from a previous welfare check. If the subject meets the criteria for an order for protective custody, that's La. R.S. 28:53.2 — I'll have the OPC checklist staged. Wait for your cover unit before contact per General Order 2.1. Hotkey when it's safe and I'll capture your notes hands-free.",
        role: 'assistant',
        timestamp: new Date(Date.now() - 240000),
      },
    ],
    'incident-3': [
      {
        id: '1',
        content:
          "Dispatching to 615 Elm Street. Pre-arrival brief: the address is tied to three narcotics complaints in the last six months and carries an active officer-safety alert from a prior resisting incident. Two known associates have outstanding warrants — I'll push their photos to your watch if you make contact. Stage for your cover unit before approach. Hotkey when it's safe and I'll capture your notes hands-free.",
        role: 'assistant',
        timestamp: new Date(Date.now() - 300000),
      },
    ],
    'ch-1': [
      {
        id: '1',
        content:
          "I've pulled your captured field notes from the Willow Street scene — eleven voice notes and four typed entries from this afternoon. Let's turn them into the patrol report. First, confirm the incident date and time so the narrative header matches your CAD entry.",
        role: 'assistant',
        timestamp: new Date(Date.now() - 1200000),
      },
      {
        id: '2',
        content: 'June 22, 2025 at approximately 9:30 PM.',
        role: 'user',
        timestamp: new Date(Date.now() - 1100000),
      },
      {
        id: '3',
        content:
          'Got it — that lines up with Mrs. Gable\'s sighting in your notes. The facts you captured point to a residential burglary, which in Louisiana is simple burglary of an inhabited dwelling under La. R.S. 14:62.2. Walk me through what you found and I\'ll confirm each element as we go.',
        role: 'assistant',
        timestamp: new Date(Date.now() - 1000000),
      },
      {
        id: '4',
        content: 'It was a burglary at a residence.',
        role: 'user',
        timestamp: new Date(Date.now() - 900000),
      },
      {
        id: '5',
        content:
          'Understood. Your captured notes list 123 Willow Street — confirm that\'s the full address and that it\'s a single-family residence, so the inhabited-dwelling element is clean.',
        role: 'assistant',
        timestamp: new Date(Date.now() - 800000),
      },
      {
        id: '6',
        content: 'Private residence at 123 Willow Street.',
        role: 'user',
        timestamp: new Date(Date.now() - 700000),
      },
      {
        id: '7',
        content:
          'Good. To establish the dwelling was inhabited at the time, was anyone present, and what was their condition?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 600000),
      },
      {
        id: '8',
        content: 'The homeowner, Mrs. Jane Doe, was present but uninjured.',
        role: 'user',
        timestamp: new Date(Date.now() - 500000),
      },
      {
        id: '9',
        content:
          'That satisfies "inhabited." The next element is unauthorized entry. Your 14:35 voice note flagged the rear door — confirm the forced-entry observations for the narrative.',
        role: 'assistant',
        timestamp: new Date(Date.now() - 400000),
      },
      {
        id: '10',
        content: 'Yes—back door kicked in, clear shoeprints near entry.',
        role: 'user',
        timestamp: new Date(Date.now() - 300000),
      },
      {
        id: '11',
        content:
          'Forced entry confirms the unauthorized-entry element. The last element is intent to commit a theft or felony inside — the missing jewelry box in your notes covers that. Confirm the evidence you logged and any witness statements so I can cite them in the report.',
        role: 'assistant',
        timestamp: new Date(Date.now() - 200000),
      },
      {
        id: '12',
        content:
          'I recovered a pry bar from the yard and got a statement from Mrs. Greene, next door.',
        role: 'user',
        timestamp: new Date(Date.now() - 100000),
      },
      {
        id: '13',
        content:
          "All three elements of La. R.S. 14:62.2 are supported by your captured notes and evidence. I've assembled the narrative, linked the pry bar and shoeprints to your evidence log, and verified your body-worn camera activation matches General Order 4.12. Want to review the draft now, or add anything before I finalize?",
        role: 'assistant',
        timestamp: new Date(),
      },
    ],
    'ch-2': [
      {
        id: '1',
        content:
          'I have a tip about possible suspects linked to the Willow Street burglary.',
        role: 'user',
        timestamp: new Date(Date.now() - 400000),
      },
      {
        id: '2',
        content:
          'Good lead. Who provided the tip, and when did they observe the activity?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 380000),
      },
      {
        id: '3',
        content:
          'The business owner saw a white van parked behind the building last night around 10 PM, with two subjects unloading bags.',
        role: 'user',
        timestamp: new Date(Date.now() - 350000),
      },
      {
        id: '4',
        content:
          'Thanks. Describe the vehicle in more detail — make, model, and any part of the plate?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 320000),
      },
      {
        id: '5',
        content: "It was a white cargo-style van, partial plate 'L7K'.",
        role: 'user',
        timestamp: new Date(Date.now() - 300000),
      },
      {
        id: '6',
        content:
          'That matches the partial plate you captured on scene at 14:25 and the BOLO already on file for this case. Did the tip include descriptions of the individuals or any distinguishing features?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 280000),
      },
      {
        id: '7',
        content:
          'No clear description, but the business owner mentioned one suspect wore a dark hoodie and the other wore a mask.',
        role: 'user',
        timestamp: new Date(Date.now() - 250000),
      },
      {
        id: '8',
        content:
          'Got it. Is there any video or photo evidence available, and if so, where can you collect it?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 200000),
      },
      {
        id: '9',
        content:
          'Yes—surveillance footage is available. I can retrieve it from the business today.',
        role: 'user',
        timestamp: new Date(Date.now() - 150000),
      },
      {
        id: '10',
        content:
          "Good. Secure the footage and note its location. What's the best contact for follow-up questions?",
        role: 'assistant',
        timestamp: new Date(Date.now() - 100000),
      },
      {
        id: '11',
        content: 'You can reach the owner, Mr. Allen, at (555) 123-4567.',
        role: 'user',
        timestamp: new Date(Date.now() - 50000),
      },
      {
        id: '12',
        content:
          "I've attached this tip to the Willow Street case file and flagged it for CID review with every detail recorded: tipster, timing, vehicle match to your existing BOLO, descriptions, and evidence location. Anything else to add?",
        role: 'assistant',
        timestamp: new Date(),
      },
    ],
    'ch-3': [
      {
        id: '1',
        content: 'Show me all new leads for the Willow Street case.',
        role: 'user',
        timestamp: new Date(Date.now() - 120000),
      },
      {
        id: '2',
        content: `Leads for Willow St. Burglary (Case #2024-0721):

• Patrol Lead [06/21 13:22]: Business owner reports white van (L7K...) unloading bags; surveillance video available. Status: Pending Evidence Collection
• Social Media [06/21 12:44]: Anonymous tip—stolen property posted for sale in local Facebook group. Status: Under Review
• Public Submission [06/21 10:19]: Neighbor submitted photo of unknown subject in alley, 03:20am. Status: Needs Patrol Follow-Up

Would you like an investigation status update?`,
        role: 'assistant',
        timestamp: new Date(Date.now() - 100000),
      },
      {
        id: '3',
        content: 'Yes, give me the investigation status.',
        role: 'user',
        timestamp: new Date(Date.now() - 80000),
      },
      {
        id: '4',
        content: `[Thinking…]
• Multiple leads reference late-night activity in the alley and a white van at different locations.
• The van links the business tip to potential stolen property movement—possible use as a mobile stash or getaway.
• Surveillance video can establish a visual ID and timeline; compare with social media post timing.
• Anonymous social post appeared within 2 hours of the burglary—suggests rapid disposal or insider involvement.
• Toolmarks on the pry bar and shoeprints could tie to recent cases; recommend latent print and toolmark comparison.
• No current suspects. Pattern indicates organized activity, not random.
[End of thinking]`,
        role: 'assistant-thinking',
        timestamp: new Date(Date.now() - 70000),
      },
      {
        id: '5',
        content: `Investigation Status [Willow St. Burglary]:
- Forced entry at rear confirmed; pry bar and shoeprints logged as evidence.
- Three leads active: van surveillance footage pending, social media sale post flagged, public-submitted photo in queue for patrol follow-up.
- Immediate action: Retrieve surveillance video, assign digital forensics review for social media accounts, confirm timeline with neighbor.
- No suspects in custody. Case active and high-priority.

Insight:
The timing of the sale posts online strongly suggests suspects are monitoring social media trends, or using a third party for quick fencing. Recommend cross-checking with area pawnshops and reviewing similar burglary MOs in surrounding jurisdictions.

Would you like to assign follow-ups, generate an evidence summary, or request deeper link analysis across cases?`,
        role: 'assistant',
        timestamp: new Date(Date.now() - 60000),
      },
      {
        id: '6',
        content:
          'Analyze the social media activity around the time of the burglary.',
        role: 'user',
        timestamp: new Date(Date.now() - 40000),
      },
      {
        id: '7',
        content: `[Thinking…]
• Reviewing local buy/sell groups and classified ads between 00:00–06:00, June 21.
• Scanning for keywords: "electronics", "tools", "moving sale", and items matching stolen property description.
• Matching timestamps of posts with burglary event log and van sighting.
• Flagging new accounts with no local connections or recent profile activity spikes.
[End of thinking]`,
        role: 'assistant-thinking',
        timestamp: new Date(Date.now() - 35000),
      },
      {
        id: '8',
        content: `Social Media Analysis:
- Two suspicious posts in buy/sell groups within 90 minutes of the burglary, offering electronics and jewelry—minimal details, vague locations.
- Both accounts created within last 24 hours, no mutual friends, identical grammar and phrasing.
- Electronics seller posted at 1:55am, matching van presence on surveillance.

Insight:
These accounts were likely created specifically to fence stolen property. Offering known-stolen goods for sale supports illegal possession of stolen things under La. R.S. 14:69. Recommend a platform data-retention request and a controlled buy or digital trace. Pattern is consistent with the recent cluster of quick-flip burglaries tracked by CID analytics.

Would you like to escalate these leads, request subpoenas, or compare to previous burglary series?`,
        role: 'assistant',
        timestamp: new Date(Date.now() - 30000),
      },
    ],
    'ch-4': [
      {
        id: '1',
        content:
          'I need best practices for a mental health crisis response—subject is agitated but nonviolent.',
        role: 'user',
        timestamp: new Date(Date.now() - 400000),
      },
      {
        id: '2',
        content:
          'Per General Order 6.3 (Response to Persons in Crisis), §6.3.2, and La. R.S. 28:53.2 (peace officer custody / order for protective custody), secure a safe perimeter and begin verbal de-escalation. Keep at least six feet of distance, speak calmly and empathetically, and avoid sudden movements. Any hazards present (weapons, bystanders)? Any prior mental health calls here?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 380000),
      },
      {
        id: '3',
        content:
          'No weapons present. The subject asked to remain alone—previous call six months ago for similar agitation.',
        role: 'user',
        timestamp: new Date(Date.now() - 350000),
      },
      {
        id: '4',
        content:
          'Understood. De-escalation steps:\n' +
          '1) Offer a Crisis Intervention Team response (General Order 6.3, App. B §2).\n' +
          '2) Suggest a voluntary wellness evaluation by the mobile crisis unit.\n' +
          '3) If the subject becomes a danger to self or others, the criteria for protective custody under La. R.S. 28:53.2 are met—initiate the OPC process.\n' +
          'Document each offer and the subject\'s response with timestamps.',
        role: 'assistant',
        timestamp: new Date(Date.now() - 320000),
      },
      {
        id: '5',
        content:
          'Yes, please generate that template outlining steps, policy citations, and statute references.',
        role: 'user',
        timestamp: new Date(Date.now() - 300000),
      },
      {
        id: '6',
        content:
          "Here's your template:\n" +
          '- **Scene Assessment** (General Order 6.3.2): Secure perimeter; note hazards.\n' +
          '- **Verbal De-escalation**: Maintain safe distance; use an empathetic tone.\n' +
          '- **Crisis Intervention Team Offer** (App. B §2): Record acceptance or refusal.\n' +
          '- **Protective Custody** (La. R.S. 28:53.2): If danger to self or others persists, initiate the OPC process and cite the statute.\n' +
          '- **Documentation**: Log all offers, responses, and actions with timestamps.\n\n' +
          'Want this formatted for your RMS?',
        role: 'assistant',
        timestamp: new Date(),
      },
    ],
    'ch-5': [
      {
        id: '1',
        content:
          "Let's coordinate a youth engagement event for the west side precinct.",
        role: 'user',
        timestamp: new Date(Date.now() - 300000),
      },
      {
        id: '2',
        content:
          'Good initiative. I can generate text-based deliverables: a press release draft, social media copy, an email invitation, or flyer text. Which messaging focus—mentorship showcase or community partnership?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 280000),
      },
      {
        id: '3',
        content: "Let's highlight mentorship and community partnership.",
        role: 'user',
        timestamp: new Date(Date.now() - 250000),
      },
      {
        id: '4',
        content:
          '**Press Release Title:** "Department Launches Youth Mentorship Initiative on the West Side"\n\n' +
          '**Lead Paragraph:** "On July 15, 2025, the West Side Precinct will host aspiring young leaders for a day of mentorship, safety workshops, and community dialogue, fostering stronger bonds between officers and residents."\n\n' +
          '**Sample Social Media Posts:**\n' +
          '1. "Join us July 15 for a Youth Mentorship Event! Officers and community leaders will share insights and guidance. #WestSideMentors"\n' +
          '2. "Mentorship matters. See how our officers empower youth through safety workshops and leadership sessions. RSVP today. #CommunityPartnership"\n\n' +
          '**Flyer Text:**\n' +
          '"Free Youth Mentorship Event\n' +
          'Date: July 15, 2025\n' +
          'Location: West Side Precinct\n' +
          'Meet local officers, build leadership skills, and strengthen community ties.\n' +
          'RSVP: community@department.gov"\n\n' +
          'Want any edits or additional variations?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 200000),
      },
      {
        id: '5',
        content:
          'This is great—can you also generate a short video script for officer testimonials?',
        role: 'user',
        timestamp: new Date(Date.now() - 150000),
      },
      {
        id: '6',
        content:
          "Here's a 30-second script:\n\n" +
          '1. **Opening Scene:** Officer Smith greets teens at the precinct entrance: "I grew up here, and giving back means the world to me."\n\n' +
          '2. **Workshop Cut:** Officer Brown demonstrates a safety exercise: "Mentorship isn\'t just teaching—it\'s listening and learning together."\n\n' +
          '3. **Closing Scene:** Group shot with officers and participants. Voiceover: "Join us July 15 to connect, learn, and grow together. #WestSideMentors"\n\n' +
          "Let me know if you'd like alternative versions or timing adjustments.",
        role: 'assistant',
        timestamp: new Date(),
      },
    ],
    bodyCameraPolicy: [
      {
        id: '1',
        content:
          "Can you clarify our agency's protocol for body camera activation during a traffic stop?",
        role: 'user',
        timestamp: new Date(Date.now() - 1000000),
      },
      {
        id: '2',
        content:
          "Here's your agency's body-worn camera protocol for traffic stops, per General Order 4.12 (Body-Worn Cameras), §4.12.3:\n\n1. Activate before any citizen contact, including while approaching the vehicle.\n2. Maintain a continuous recording for the full duration of the stop, without interruption.\n3. Announce the recording to the subject at first opportunity.\n4. Do not deactivate until the stop and all citizen contact are concluded.\n\nWant detail on retention, supervisor review, or report linkage?",
        role: 'assistant',
        timestamp: new Date(Date.now() - 900000),
      },
      {
        id: '3',
        content:
          'Yes—when is the exact moment to start recording? Some situations develop quickly.',
        role: 'user',
        timestamp: new Date(Date.now() - 800000),
      },
      {
        id: '4',
        content:
          "Per General Order 4.12.3(a): begin recording the moment you form the intent to stop—before lights or siren, before any approach. That captures your pre-stop observations, verbal commands, and the subject's reactions for evidentiary and liability purposes. When in doubt, start early—an over-inclusive recording is defensible; a gap is not.",
        role: 'assistant',
        timestamp: new Date(Date.now() - 700000),
      },
    ],
  },
  transcripts: {
    'bc-1': [
      {
        id: '1',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'Initiating traffic stop on silver sedan, plate ABC-123, for suspected DUI. Location: Highway 26, westbound, mile marker 43.',
        timestamp: '14:30:00',
      },
      {
        id: '2',
        speaker: 'Dispatch',
        content: 'Copy, Officer Smith. Plate ABC-123 logged. Backup available.',
        timestamp: '14:30:15',
      },
      {
        id: '3',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'Driver displays slurred speech, bloodshot eyes, and slow coordination. Requesting backup for field sobriety evaluation.',
        timestamp: '14:35:22',
      },
      {
        id: '4',
        speaker: 'Officer Jones',
        badge: '#67890',
        content:
          "Backup en route, ETA 2 minutes. Proceed with standard SFST—request driver's license, registration, proof of insurance.",
        timestamp: '14:36:05',
      },
      {
        id: '5',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'Driver, do you have your license and registration? (pause) You seem unsteady—have you had anything to drink today?',
        timestamp: '14:37:10',
      },
      {
        id: '6',
        speaker: 'Driver',
        content:
          "Uh, I had a couple of beers earlier, officer, but I'm fine to drive.",
        timestamp: '14:37:45',
      },
      {
        id: '7',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          "Alright. I'm going to conduct some standardized field sobriety tests. Follow my pen with your eyes only—no head movement.",
        timestamp: '14:38:10',
      },
      {
        id: '8',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'I observed six out of six clues on the Horizontal Gaze Nystagmus test. Now please stand heel-to-toe and walk nine steps forward, turn, and walk back.',
        timestamp: '14:38:55',
      },
      {
        id: '9',
        speaker: 'Driver',
        content:
          "(stumbles) Am I doing it right? Sorry, it's a bit slippery here.",
        timestamp: '14:39:30',
      },
      {
        id: '10',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'You stepped off the line twice and used your arms to balance. The test indicates impairment. One-leg stand next—lift your right foot six inches off the ground and count aloud.',
        timestamp: '14:40:05',
      },
      {
        id: '11',
        speaker: 'Dispatch',
        content: 'Officer Smith, confirm if you need breathalyzer at scene.',
        timestamp: '14:40:30',
      },
      {
        id: '12',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          "Affirmative—please send the handheld unit. Driver, I'm placing you under arrest for suspicion of DUI. You have the right to remain silent… (Miranda warning).",
        timestamp: '14:41:00',
      },
      {
        id: '13',
        speaker: 'Dispatch',
        content:
          'Handheld breathalyzer units dispatched. Station ETA is 1430 Sibley Street, approximately 8 minutes out.',
        timestamp: '14:41:20',
      },
      {
        id: '14',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'Driver refused on-scene breath test. I will transport to station for evidentiary breath test. Secure the vehicle and advise towing.',
        timestamp: '14:42:10',
      },
    ],

    'bc-2': [
      {
        id: '1',
        speaker: 'Officer Johnson',
        badge: '#67890',
        content:
          'Arrived at 1245 Oak Street for domestic disturbance. Neighbors reported shouting from inside.',
        timestamp: '18:05:00',
      },
      {
        id: '2',
        speaker: 'Officer Johnson',
        badge: '#67890',
        content:
          'Contacted male subject—appears agitated, confirmed verbal dispute with partner. No sign of assault or physical altercation.',
        timestamp: '18:07:45',
      },
    ],
    'bc-3': [
      {
        id: '1',
        speaker: 'Officer Lee',
        badge: '#22331',
        content:
          'Located suspicious vehicle, NE mall lot. Dark blue SUV, missing rear license plate.',
        timestamp: '16:12:00',
      },
      {
        id: '2',
        speaker: 'Officer Lee',
        badge: '#22331',
        content:
          'VIN scan—vehicle associated with recent shoplifting. Requesting secondary unit for vehicle search.',
        timestamp: '16:14:18',
      },
    ],
    'bc-4': [
      {
        id: '1',
        speaker: 'Officer Davis',
        badge: '#33221',
        content:
          'Wellness check: 782 Pine Lane. Elderly resident not answering door, reported by neighbor.',
        timestamp: '11:22:00',
      },
      {
        id: '2',
        speaker: 'Officer Davis',
        badge: '#33221',
        content:
          'Resident located, conscious but confused. Notified EMS, providing assistance until paramedics arrive.',
        timestamp: '11:25:33',
      },
    ],
  },
  transcriptChats: {
    'bc-1': [
      {
        id: 'tc-1',
        role: 'assistant',
        content:
          "Let's assemble the report from your bodycam transcript. The facts support a charge under La. R.S. 14:98 (operating while intoxicated). First, confirm the driver's full name, date of birth, license number, and address.",
        timestamp: new Date(Date.now() - 1500000),
      },
      {
        id: 'tc-2',
        role: 'user',
        content:
          'Driver is Jane A. Doe, DOB January 5, 1987, DL S1234567, 123 Main St, Lafayette, LA.',
        timestamp: new Date(Date.now() - 1400000),
      },
      {
        id: 'tc-3',
        role: 'assistant',
        content:
          'Got it. Next, vehicle details: make, model, year, color, VIN, and insurance carrier/policy.',
        timestamp: new Date(Date.now() - 1300000),
      },
      {
        id: 'tc-4',
        role: 'user',
        content:
          '2018 Toyota Camry, silver, VIN 4T1BF1FK5JU123456, insured by State Farm, policy #987654321.',
        timestamp: new Date(Date.now() - 1200000),
      },
      {
        id: 'tc-5',
        role: 'assistant',
        content:
          'Describe environmental conditions at the time: weather, lighting, road surface, and traffic volume.',
        timestamp: new Date(Date.now() - 1100000),
      },
      {
        id: 'tc-6',
        role: 'user',
        content:
          'Clear skies, dry pavement, daylight, moderate traffic—approximately one car every 30 seconds.',
        timestamp: new Date(Date.now() - 1000000),
      },
      {
        id: 'tc-7',
        role: 'assistant',
        content:
          'For the probable-cause narrative supporting the 14:98 stop, confirm your odor observations, any admission of drinking, and your training/experience basis.',
        timestamp: new Date(Date.now() - 900000),
      },
      {
        id: 'tc-8',
        role: 'user',
        content:
          "I detected a strong odor of intoxicants on the driver's breath; they admitted to two beers. Based on my training, this supported impairment suspicion.",
        timestamp: new Date(Date.now() - 800000),
      },
      {
        id: 'tc-9',
        role: 'assistant',
        content:
          'Which device was used for the preliminary breath test? Provide make, model, serial number, and time administered.',
        timestamp: new Date(Date.now() - 700000),
      },
      {
        id: 'tc-10',
        role: 'user',
        content: 'Handheld Intoxilyzer 8000, SN 56789, administered at 14:42.',
        timestamp: new Date(Date.now() - 600000),
      },
      {
        id: 'tc-11',
        role: 'assistant',
        content:
          'Any additional witness statements or backup officer observations to include?',
        timestamp: new Date(Date.now() - 500000),
      },
      {
        id: 'tc-12',
        role: 'user',
        content:
          'Officer Jones (#67890) noted the same impairment clues and assisted during FSTs; his statement concurs.',
        timestamp: new Date(Date.now() - 400000),
      },
      {
        id: 'tc-13',
        role: 'assistant',
        content:
          "Excellent. Your transcript shows the driver refused the on-scene breath test—I've documented the implied-consent advisory under La. R.S. 32:661 and noted the evidentiary breath test at the station. I'll assemble the full La. R.S. 14:98 report from your bodycam transcript and these details. Ready to review?",
        timestamp: new Date(Date.now() - 300000),
      },
    ],

    'bc-2': [
      {
        id: 'tc-4',
        role: 'assistant',
        content:
          'This is flagged as a domestic disturbance. From your bodycam transcript I can draft a scene report capturing subject statements, scene conditions, and the absence of injury. Note: with a verbal dispute and no battery, the elements of domestic abuse battery (La. R.S. 14:35.3) are not met—I\'ll document it as a disturbance, not an arrestable offense. Where would you like to begin?',
        timestamp: new Date(Date.now() - 700000),
      },
      {
        id: 'tc-6',
        role: 'assistant',
        content:
          'Based on your bodycam recording, I can generate a draft report: summary of the verbal conflict, statements from involved parties, and confirmation of no observed injuries. Proceed?',
        timestamp: new Date(),
      },
    ],
    'bc-3': [
      {
        id: 'tc-5',
        role: 'assistant',
        content:
          'Suspicious vehicle confirmed as matching the active BOLO. The stolen-vehicle return supports charges under La. R.S. 14:69 (illegal possession of stolen things). Would you like the related case files, or should I begin pre-filling the evidence and recovery documentation?',
        timestamp: new Date(Date.now() - 600000),
      },
      {
        id: 'tc-7',
        role: 'assistant',
        content:
          'Vehicle matches the shoplifting alert. Pre-filling the case reference and evidence-collection sections now. Anything to add before submission?',
        timestamp: new Date(),
      },
    ],
    'bc-4': [
      {
        id: 'tc-8',
        role: 'assistant',
        content:
          'Welfare check completed—elder at risk. Indications of possible neglect trigger the mandatory adult-abuse reporting requirement under La. R.S. 15:1504. I can flag for follow-up, draft the Adult Protective Services referral, and document the EMS response in the official report. Confirm update?',
        timestamp: new Date(),
      },
    ],
  },
  performance: {
    summary:
      'Officer consistently demonstrates attention to detail, thorough scene documentation, and procedural compliance. Field notes captured through BP Notes are complete and well-organized, contributing to faster report turnaround, strong case solvability rates, and positive supervisor feedback.',
    recentContributions: [
      {
        date: '2024-01-15',
        action: 'Detailed scene documentation – Willow St. burglary',
        points: '+5',
      },
      {
        date: '2024-01-14',
        action: 'Effective victim interview – Domestic disturbance',
        points: '+3',
      },
      {
        date: '2024-01-12',
        action: 'Evidence cataloging – Stolen vehicle recovery',
        points: '+4',
      },
    ],
  },
  reports: {
    default: {
      caseNumber: '2024-0123-BR',
      location: '123 Main Street',
      incidentType: 'Burglary – Breaking and Entering',
      narrative: `On January 15, 2024, at approximately 1430 hours, I, Officer Smith (#12345), responded to a reported burglary at 123 Main Street.
Upon arrival, I observed forced entry at the front door; the lock mechanism had been tampered with and the doorframe was damaged. The premises were clear on entry and no suspects were present.
The scene was documented with photographs and searched for physical evidence. Witness statements were collected from adjacent residents. A surveillance canvass was negative.
The observed facts support a charge of simple burglary of an inhabited dwelling, La. R.S. 14:62.2. This narrative was compiled from field notes captured on scene and is submitted as a factual record of the response and investigation.`,
    },
    'bc-2': {
      caseNumber: '2024-0124-DD',
      location: '1245 Oak Street',
      incidentType: 'Domestic Disturbance',
      narrative: `At approximately 1805 hours, Officer Johnson (#67890) responded to a domestic disturbance at 1245 Oak Street.
I interviewed the male occupant and confirmed a verbal dispute with his partner. No physical altercation occurred and no injuries were observed. Neighbors reported hearing raised voices only.
Because no battery occurred, the elements of domestic abuse battery (La. R.S. 14:35.3) are not met and no charge is warranted. Both parties were advised of available community resources. The scene was cleared without incident. This report was compiled from captured field notes and forwarded for reference should future calls occur.`,
    },
    'bc-3': {
      caseNumber: '2024-0125-SV',
      location: 'Mall Parking Lot (NE corner)',
      incidentType: 'Suspicious Vehicle / Stolen Property Recovery',
      narrative: `On January 13, 2024, Officer Lee (#22331) located a suspicious dark blue SUV with no rear plate matching an active BOLO.
A VIN query returned the vehicle as stolen in a prior retail-theft case. A search recovered stolen merchandise. One male subject was detained without incident. All items were cataloged, photographed, and secured for CID processing.
The recovered property and the subject's possession support charges under La. R.S. 14:69 (illegal possession of stolen things). This report was compiled from captured field notes.`,
    },
    'bc-4': {
      caseNumber: '2024-0126-WC',
      location: '782 Pine Lane',
      incidentType: 'Wellness Check – Elderly Assist',
      narrative: `Officer Davis (#33221) conducted a welfare check at 782 Pine Lane for an elderly resident. The subject was located conscious but disoriented and dehydrated.
EMS responded and transported the subject for medical evaluation. Given indications of possible neglect, a referral was filed with Adult Protective Services consistent with the mandatory-reporting requirement under La. R.S. 15:1504. The incident was logged and social-services follow-up requested. This report was compiled from captured field notes.`,
    },
  },
  affidavit: {
    title: 'Affidavit of Truth',
    declarations: [
      'That I am a sworn law enforcement officer employed by this agency and authorized to submit this report.',
      'That the information contained herein is accurate to the best of my knowledge and belief.',
      'That this report was prepared in the regular course of official law enforcement duties.',
      'That I understand this report may be used as an official document in administrative, legal, or judicial proceedings.',
      'That I acknowledge any knowingly false statements may result in disciplinary action or prosecution.',
    ],
    confirmationText:
      'I affirm that the contents of this report are true and accurate to the best of my knowledge and belief.',
  },
}